export const labelsCacheKeys = {
  api: {
    fetchAll: () => ['labels'] as const
  }
}
